module.exports = __webpack_public_path__ + "static/media/sale-icon2.49f21a01.svg";